import Heading from 'common/components/Heading';
import Link from 'common/components/Link';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import Section, { Content } from './cta.style';

const CTA = (props) => {
  const data = useStaticQuery(graphql`
    query {
      appJson {
        callToAction {
          button {
            label
            link
          }
          content
          info
          title
        }
      }
    }
  `);

  const { appJson: callToAction } = data;

  const items = callToAction?.callToAction;

  return (
    <Section {...props} id="cta">
      <Container width="1400px">
        <Content className='cat_content_wrapper'>
          <Heading content={items?.title} />

          <Text content={items?.content} />

          <div className='call_to_action_links'>
            {items?.button?.map((button, index) => (
              <Link
                href={button?.link}
                className='call_to_action_link'
                key={button?.link || index}
                target="_blank"
                rel="noopener noreferrer"
              >
                {button?.label}
              </Link>
            ))}
          </div>

          <span className='call_to_action_info'>{items?.info}</span>
        </Content>
      </Container>
    </Section>
  );
};

export default CTA;
